import { Component, OnInit } from '@angular/core'
import { AngularFireDatabase } from 'angularfire2/database'
// import * as firebase from 'firebase'

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

	users: Array<any> = []
	head = [
		{key: 'picture', type: 'thumbnail', sort: false},
		{key: 'username'},
		{key: 'name'},
		{key: 'email'},
		{key: 'last_connection', display: 'Last connection', type: 'moment'},
		{key: 'registration_date', display: 'Signed up', type: 'moment'},
	]

	constructor(
		private db: AngularFireDatabase,
	){}

	ngOnInit() {
		let sub = this.db.object('users').valueChanges().subscribe(users => {
			// sub.unsubscribe()
			this.users = Object.values(users)
		})
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/users/users.component.ts